import { EndMarker } from '../domain/page';
import Vue from 'vue';
import { nextTick } from './next_tick';

export class Vue2EndMarker implements EndMarker {
    data = Vue.observable({ enabled: false });

    async enable(): Promise<void> {
        nextTick(() => {
            this.data.enabled = true;
        });
    }

    async disable(): Promise<void> {
        nextTick(() => {
            this.data.enabled = false;
        });
    }
}